var map = {
	"./checkin.png": "2e3b",
	"./myqrcode.png": "d6a8",
	"./new_all.svg": "2430",
	"./new_arts.svg": "c2bf",
	"./new_business.svg": "b8ba",
	"./new_charitable.svg": "6307",
	"./new_design.svg": "6a9c",
	"./new_entertainment.svg": "55f9",
	"./new_family.svg": "c5fa",
	"./new_fashion.svg": "4e07",
	"./new_film.svg": "9df4",
	"./new_food.svg": "9aef",
	"./new_game.svg": "2d12",
	"./new_handmade.svg": "ca5a",
	"./new_health.svg": "2992",
	"./new_investment.svg": "d1df",
	"./new_learning.svg": "4583",
	"./new_learning_focus.svg": "1c5f",
	"./new_music.svg": "1e8a",
	"./new_pet.svg": "d9d3",
	"./new_photography.svg": "13e8",
	"./new_sports.svg": "1b67",
	"./new_startup.svg": "f3dd",
	"./new_technology.svg": "6c2e",
	"./new_travel.svg": "9266"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";